import { z } from 'zod';

export const clipKindSchema = z.enum(['base', 'vertical']);

export type IClipKind = z.infer<typeof clipKindSchema>;
